import { KeyboardEvent } from 'react';

const DIGIT_KEY = /^\d$/;

export const preventNonDigitKey = (event: KeyboardEvent<HTMLOwcInputElement> | undefined): void => {
    if (!event) {
        return;
    }

    const { key, ctrlKey, metaKey } = event.nativeEvent;
    if (typeof key === 'string' && key.length === 1 && !DIGIT_KEY.test(key) && !ctrlKey && !metaKey) {
        event.preventDefault();
    }
};
